/* eslint-disable no-underscore-dangle */
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanMatchFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Usuario } from '../models/usuario';
import { environment } from 'src/environments/environment';
import { EchoService } from '../providers/echo.service';
import { ConnectionStatus, Network } from '@capacitor/network';
import { Capacitor, CapacitorHttp, registerPlugin } from '@capacitor/core';
import { SavePassword } from 'capacitor-ios-autofill-save-password';
import { UsuarioService } from 'src/app/services/usuario.service';
import { BaseService } from '../services/_base.service';
import { Sinistro } from 'src/app/models/sinistro';
import { Edificacao } from 'src/app/models/edificacao';
// import { BackgroundMode } from '@awesome-cordova-plugins/background-mode/ngx';
import { Haptics } from '@capacitor/haptics';
import { Geolocation, Position } from '@capacitor/geolocation';
import { Directory, Filesystem } from '@capacitor/filesystem';
import { AndarDBService } from 'src/app/database/andar-db.service';
import { EdificacaoDBService } from 'src/app/database/edificacao-db.service';
import { AlertController, Platform, ToastController } from '@ionic/angular';
import { FilaDBService } from 'src/app/database/fila-db.service';
import { BackgroundMode } from '@anuradev/capacitor-background-mode';
import { AndroidSettings, IOSSettings, NativeSettings } from 'capacitor-native-settings';
import { Cliente } from 'src/app/models/cliente';
import { Estabelecimento } from 'src/app/models/estabelecimento';
import { Brigadista } from 'src/app/models/brigadista';
import { Simulacao } from 'src/app/models/simulacao';
import { Mensagem } from 'src/app/models/mensagem';
import { PontoEncontroPresenca } from 'src/app/models/ponto-encontro';
import { SincService } from 'src/app/services/sinc.service';
import { StorageService } from '../services/storage.service';
import { Helper } from '../providers/helper';
import { UploadQueueService } from 'src/app/services/upload-queue.service';
import { BiometriaService } from 'src/app/services/biometria.service';
import { PagesPage } from 'src/app/pages/pages.page';
// import { SignInWithAppleResponse } from '@capacitor-community/apple-sign-in';
// import { User } from '@codetrix-studio/capacitor-google-auth/dist/esm/definitions';

declare global {
    interface Window {
        PasswordCredential?: any;
    }
}

export interface DuploFatorPendente {
    duplo_fator: boolean;
    desafio_id: number;
    email_mascarado: string;
    expira_em?: string;
    remember_me: boolean;
}

const BackgroundPermissions = registerPlugin<{
    checkOverlayPermission(): Promise<{ granted: boolean }>;
}>('BackgroundPermissions');

@Injectable({
    providedIn: 'root'
})
export class AuthGuard {

    public token: any;
    public usuario: Usuario | undefined;
    public event: BehaviorSubject<any> = new BehaviorSubject(null);
    public users: Usuario[] = [];
    public chatAtivo: string | null = null;
    public position: Position | null = null;
    public presenca?: PontoEncontroPresenca;
    private go: string | undefined;
    private _appkey: string | undefined;
    private _webkey: string | undefined;
    private GPS: any;
    private WATCH: any;
    private biometriaAutenticada = false;
    private androidBackgroundPermissionsChecked = false;


    constructor(private storage: StorageService,
        // private backgroundMode: BackgroundMode,
        private platform: Platform,
        private router: Router,
        private http: HttpClient,
        private alertController: AlertController,
        private toastController: ToastController,
        private filaDB: FilaDBService,
        private uploadQueue: UploadQueueService,
        private sinc: SincService,
        private service: UsuarioService,
        private andarDB: AndarDBService,
        private edificacaoDB: EdificacaoDBService,
        private echo: EchoService,
        private biometria: BiometriaService){
            this.initialize();
    }

    initialize(){
        this.platform.ready().then(() => {

            this.getUsuario().subscribe(() => {

                Network.removeAllListeners().then(() => {
                    Network.addListener('networkStatusChange', status => {
                        this.chkConnection(status);
                    });
                });

                this.logCurrentNetworkStatus();
            })
        })
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        this.go = state.url;

        return this.storage.get('user').then((r) =>{
            if(r || this.token){
                //this.router.navigate(['/']);
                return this.usuario ? true : false;
            }

            this.router.navigate(['/hall']);
            return false;
        });
    }

    login(data: {email: string; senha: string; remember_me: boolean}){
        this.http.post(environment.url + 'login', data).subscribe((r: any) => {
            if(this.isDuploFator(r)){
                this.iniciarDuploFator(r, data.remember_me);
                return;
            }

            this.salvarSenhaSistema(data);
            this.finalizarLogin(r, data.remember_me);
        });
    }

    logout(){
        if(this.online())
            this.http.post(environment.url + 'logout', null).subscribe({
                error: () => { this.clear(true) },
                complete: () => { this.clear(true) }
            });
        else
            this.clear(true);
    }

    remove(){
        this.http.delete(environment.url + 'usuario/' + this.usuario?.id).subscribe((r) => {
            this.clear(true);
        });
    }

    getUsuario(): Observable<boolean> {
        return new Observable((subscriber) => {
            this.storage.get('user').then((r) => {
                if(r || this.token){
                    this.http.get<Usuario>(environment.url + 'user', {headers: {authorization: 'Bearer ' + (r ? r.access_token : this.token.access_token)}}).subscribe((u) => {
                        this.storage.get('usuario').then(async (usuario) => {
                            const usuarioAnterior = usuario ? new Usuario(usuario) : undefined;
                            const usuarioAtual = new Usuario(u);
                            await this.atualizarEscopoSincronizacao(usuarioAtual, usuarioAnterior);

                            this.storage.set('usuario', u);
                            this.usuario = usuarioAtual;

                            const biometriaOk = await this.verificarBiometria();
                            if(!biometriaOk){
                                subscriber.next(false);
                                return;
                            }

                            this.updateFirebaseTokens();

                            this.usuario.admin ? null : this.listen();

                            this.usuario.admin ? null : this.offline(usuarioAnterior?.id === usuarioAtual.id ? usuarioAnterior : undefined);

                            if(this.go){
                                this.router.navigateByUrl(this.go);
                                this.go = undefined;
                            }

                            subscriber.next(true);
                        })

                    }, (e) => {
                        // console.log(e)
                        this.storage.get('usuario').then((r) => {
                            if(r){
                                this.usuario = new Usuario(r);
                                subscriber.next(true);

                                this.listen();

                                if(this.go){
                                    this.router.navigateByUrl(this.go);
                                    this.go = undefined;
                                }
                            }else{
                                this.usuario = undefined;
                                subscriber.next(false);
                            }
                        });
                    });
                }else{
                    this.usuario = undefined;
                    subscriber.next(false);
                }
            });
        });
    }

    update(data: any): Observable<Usuario>{
        return new Observable((subscriber) => {
            this.service.put(data, null, null, {showLoader: 'false'}).subscribe((r) => {
                subscriber.next(r);
            });
        });
    }

    register(data: any){
        this.http.post(environment.url + 'registrar', data).subscribe((r: any) => {
            if(r.aguardando_aprovacao){
                this.alertController.create({
                    header: 'Cadastro recebido',
                    message: 'Seu cadastro foi enviado para aprovação. O acesso será liberado após a confirmação pelo responsável.',
                    buttons: ['OK']
                }).then(alerta => alerta.present());
                return;
            }
            if(r.access_token){
                this.finalizarLogin(r, true);
            }else if(this.isDuploFator(r)){
                this.iniciarDuploFator(r, true);
            }else
                this.login({email: (data.metadata?.google ? data.metadata.id + '@e-brigada.com.br' : (data.metadata?.apple ? data.metadata.user + '@e-brigada.com.br' : data.email)), senha: data.password, remember_me: true});
        });
    }

    check(data: any){
        return this.http.post(environment.url + 'checar', data).pipe(
            map((r: any) => {
                if(r.access_token){
                    this.finalizarLogin(r, true);
                }else if(this.isDuploFator(r)){
                    this.iniciarDuploFator(r, true);
                }
            })
        );
    }

    validarDuploFator(codigo: string){
        this.getDuploFatorPendente().then((desafio) => {
            if(!desafio){
                this.router.navigate(['/hall']);
                return;
            }

            this.http.post(environment.url + 'login/duplo-fator', {
                desafio_id: desafio.desafio_id,
                codigo
            }).subscribe((r: any) => {
                this.storage.del('duplo_fator');
                this.finalizarLogin(r, desafio.remember_me);
            });
        });
    }

    reenviarDuploFator(): Observable<DuploFatorPendente> {
        return new Observable((subscriber) => {
            this.getDuploFatorPendente().then((desafio) => {
                if(!desafio){
                    subscriber.error();
                    this.router.navigate(['/hall']);
                    return;
                }

                this.http.post<DuploFatorPendente>(environment.url + 'login/duplo-fator/reenviar', {
                    desafio_id: desafio.desafio_id
                }).subscribe({
                    next: (r) => {
                        const novo = Object.assign({}, r, {remember_me: desafio.remember_me});
                        this.storage.set('duplo_fator', novo).then(() => {
                            subscriber.next(novo);
                            subscriber.complete();
                        });
                    },
                    error: (e) => subscriber.error(e)
                });
            });
        });
    }

    getDuploFatorPendente(): Promise<DuploFatorPendente | undefined> {
        return this.storage.get('duplo_fator');
    }

    resetar(data: any){
        return this.http.post(environment.url + 'resetar', data);
    }

    private isDuploFator(r: any): boolean {
        return !!r?.duplo_fator && !!r?.desafio_id;
    }

    private iniciarDuploFator(r: any, remember_me: boolean){
        const desafio: DuploFatorPendente = {
            duplo_fator: true,
            desafio_id: r.desafio_id,
            email_mascarado: r.email_mascarado,
            expira_em: r.expira_em,
            remember_me
        };

        this.storage.set('duplo_fator', desafio).then(() => {
            this.router.navigate(['/hall/duplo-fator']);
        });
    }

    private finalizarLogin(r: any, remember_me: boolean){
        this.storage.del('duplo_fator');
        this.biometriaAutenticada = true;

        if(remember_me){
            this.storage.set('user', r).then(() => {
                this.getUsuario().subscribe(() => {
                    this.router.navigate(['/']);
                });
            });
        }else{
            this.token = r;
            this.echo.token = r;
            this.getUsuario().subscribe(() => {
                this.router.navigate(['/']);
            });
        }
    }

    private cacheOwner(usuario: Usuario): string{
        return String(usuario.id || '');
    }

    private async atualizarEscopoSincronizacao(usuarioAtual: Usuario, usuarioAnterior?: Usuario): Promise<void>{
        if(await this.storage.get('session')){
            return;
        }

        const ownerAtual = this.cacheOwner(usuarioAtual);
        const ownerAnterior = await this.storage.get('sync_owner') || (usuarioAnterior ? this.cacheOwner(usuarioAnterior) : null);

        const edificacaoAlterada = usuarioAnterior?.id === usuarioAtual.id
            && !!usuarioAnterior?.brigadista && !!usuarioAtual.brigadista
            && usuarioAnterior.edificacao?.id !== usuarioAtual.edificacao?.id;
        if(Capacitor.isNativePlatform() && ((ownerAnterior && ownerAnterior !== ownerAtual) || edificacaoAlterada)){
            await this.sinc.resetarSincronizacao();
        }

        await this.storage.set('sync_owner', ownerAtual);
    }

    private salvarSenhaSistema(data: {email: string; senha: string}){
        if (Capacitor.getPlatform() === 'ios') {
            SavePassword.promptDialog({
                username: data.email,
                password: data.senha
            });
        }else if ("PasswordCredential" in window) {
            let credential = new window.PasswordCredential({
                id: data.email,
                password: data.senha
            });
            navigator.credentials.store(credential);
        }
    }

    private async verificarBiometria(): Promise<boolean> {
        if(!this.usuario?.auth_config?.app_biometria_desbloqueio){
            await this.storage.del('biometria_desbloqueio');
            this.biometriaAutenticada = false;
            return true;
        }

        const habilitada = await this.biometriaHabilitada();
        if(!habilitada || this.biometriaAutenticada){
            return true;
        }

        if(!this.usuario.auth_config?.app_manter_token_com_biometria){
            await this.limparCredenciais();
            this.usuario = undefined;
            this.token = null;
            this.router.navigate(['/hall']);
            return false;
        }

        const ok = await this.biometria.autenticar();
        if(ok){
            this.biometriaAutenticada = true;
            return true;
        }

        await this.limparCredenciais();
        this.usuario = undefined;
        this.token = null;
        this.router.navigate(['/hall']);
        return false;
    }

    async saveConf(conf: any){
        (this.usuario as Usuario).configuracao = conf;
        const data = Object.assign({}, this.usuario, {configuracao: JSON.stringify(this.usuario?.configuracao)});
        this.update(data).subscribe((r) => {
            this.logCurrentNetworkStatus();
            this.storage.get('usuario').then(r => {
                r.configuracao = conf;
                this.storage.set('usuario', r);

                // this.toastController.create({
                //     mode: 'ios',
                //     color: 'primary',
                //     message: 'configurações salvas com sucesso.',
                //     duration: 2000
                // }).then(t => t.present());
            });
        });
    }

    online(){
        return BaseService.online;
    }

    canTriggerSinistroAlarm(payload: any): boolean {
        if(!this.usuario?.estabelecimento?.conf?.silenciar_alarme_apos_primeiro_acionamento_sinistro){
            return true;
        }

        const disparar = Helper.parseBool(payload?.disparar ?? payload?.sinistro?.disparar ?? payload?.data?.disparar);
        if(disparar === undefined){
            return true;
        }
        return disparar === true;
    }

    async biometriaPermitida(): Promise<boolean> {
        return !!this.usuario?.auth_config?.app_biometria_desbloqueio;
    }

    async biometriaHabilitada(): Promise<boolean> {
        return !!(await this.storage.get('biometria_desbloqueio'));
    }

    async setBiometriaHabilitada(habilitar: boolean): Promise<boolean> {
        if(!habilitar){
            await this.storage.del('biometria_desbloqueio');
            this.biometriaAutenticada = false;
            return false;
        }

        if(!await this.biometriaPermitida()){
            await this.storage.del('biometria_desbloqueio');
            return false;
        }

        if(!await this.biometria.disponivel()){
            await this.storage.del('biometria_desbloqueio');
            return false;
        }

        const ok = await this.biometria.autenticar('Confirme sua identidade para ativar o desbloqueio');

        if(ok){
            await this.storage.set('biometria_desbloqueio', true);
            this.biometriaAutenticada = true;
            return true;
        }

        await this.storage.del('biometria_desbloqueio');
        return false;
    }

    clear(preservarDados = true){
        if(this.WATCH)
            Geolocation.clearWatch({id: this.WATCH});
        clearInterval(this.GPS);
        this.echo.remAll();
        this.usuario = undefined;
        this.users = [];
        this.chatAtivo = null;
        this.echo.token = null;
        this.token = null;
        this.biometriaAutenticada = false;

        const limpar = preservarDados ? this.limparCredenciais() : this.storage.clear();

        limpar.then(() => {
            this.router.navigate(['/hall']);
        });
    }

    private limparCredenciais(): Promise<any> {
        return Promise.all([
            this.storage.del('user'),
            this.storage.del('session'),
            this.storage.del('duplo_fator'),
            this.storage.del('biometria_desbloqueio')
        ]);
    }

    // google(user: User){
    //     this.http.post(environment.url + 'google', user).subscribe((r) => {
    //         this.storage.set('user', r).then(() => {
    //             this.getUsuario().subscribe(() => {
    //                 this.router.navigate(['/']);
    //             });
    //         });
    //     });
    // }

    // apple(user: SignInWithAppleResponse){
    //     this.http.post(environment.url + 'apple', user).subscribe((r) => {
    //         this.storage.set('user', r).then(() => {
    //             this.getUsuario().subscribe(() => {
    //                 this.router.navigate(['/']);
    //             });
    //         });
    //     });
    // }

    set appkey(v: string){
        this._appkey = v;
        this.updateFirebaseTokens();
    }

    set webkey(v: string){
        this._webkey = v;
        this.updateFirebaseTokens();
    }

    private updateFirebaseTokens(){
        this.storage.get('session').then((s) => {
            // !s &&
            if(this.usuario && ((this._appkey && this.usuario.appkey !== this._appkey) || (this._webkey && this.usuario.webkey !== this._webkey))){
                this.usuario.appkey = this._appkey ?? this.usuario.appkey;
                this.usuario.webkey = this._webkey ?? this.usuario.webkey;
                this.update(this.usuario).subscribe();
            }
        })
    }

    private startGPS(COUNTER_GPS = 0){
        if(this.WATCH){
            Geolocation.clearWatch({id: this.WATCH});
            this.WATCH = null;
        }

        Geolocation.watchPosition({
            enableHighAccuracy: true,
            timeout: 30000
        }, (pos) => {
            this.position = pos;
        }).then((id) => {
            this.WATCH = id;
            this.sendGPS();
        }, (e) => {
            COUNTER_GPS++;
            if(COUNTER_GPS == 5){
                this.toastController.create({
                    mode: 'ios',
                    color: 'tertiary',
                    icon: 'warning',
                    message: 'não foi possível obter a localização',
                    duration: 5000
                }).then(t => t.present());
            }else{
                this.startGPS(COUNTER_GPS);
            }
        });
    }

    private sendGPS(){
        this.storage.get('session').then((s) => {
            // !s &&
            if(this.online() && this.position && this.position.coords.accuracy <= (this.usuario?.edificacao as Edificacao).gps_precisao && (this.usuario?.pessoa.lat != this.position.coords.latitude || this.usuario.pessoa.lng != this.position.coords.longitude)){
                (this.usuario as Usuario).pessoa.lat = this.position.coords.latitude;
                (this.usuario as Usuario).pessoa.lng = this.position.coords.longitude;
                this.update(Object.assign({}, this.usuario?.pessoa, this.usuario)).subscribe();
            }
        });
    }

    public enableAndroidBackgroundMode(): void {
        if(!this.usuario || !Capacitor.isNativePlatform() || Capacitor.getPlatform() != 'android') return;

        BackgroundMode.enable({
            title: "E-brigada está em execução",
            text: "",
            color: "#DA2128",
            icon: "notification",
            silent: false,
            disableWebViewOptimization: true
        }).catch(error => console.warn('Background mode unavailable', error));
    }

    private listen(){

        this.echo.remAll();
        this.users = [];

        if (this.usuario?.id) {
            this.echo.addPrivate('chat.usuario.' + this.usuario.id).subscribe(channel => {
                channel.listen('ChatAtualizado', (e: {conversa_id: number, mensagem_id: number, usuario_id: number}) => {
                    if (e.mensagem_id && this.usuario && Number(e.usuario_id) !== Number(this.usuario.id)
                        && (document.hidden || this.chatAtivo !== 'c' + e.conversa_id)) {
                        this.usuario.qtd_mensagens = (this.usuario.qtd_mensagens || 0) + 1;
                    }
                    this.event.next(e);
                });
            });
        }

        if(!this.usuario?.admin){
            // if(this.usuario?.isCliente){
                this.echo.addPresence('cliente.' + this.usuario?.cliente?.id).subscribe((p) => {
                    p.socket.on('disconnect', () => { this.users = []; });
                    p.here((data: Usuario[]) => {
                        this.users = data;
                    })
                    .joining((data: Usuario) => {
                        if (!this.users.some(u => Number(u.id) === Number(data.id))) this.users.push(data);
                    })
                    .leaving((data: Usuario) => {
                        this.users = this.users.filter(u => Number(u.id) !== Number(data.id));
                    })
                    .listen('Usuario', (e: {socket: string, usuario: Usuario}) => {
                        const index = this.users.findIndex(u => Number(u.id) === Number(e.usuario.id));
                        if (index >= 0) this.users.splice(index, 1, e.usuario);
                        this.event.next(e);
                        if(this.usuario?.id == e.usuario.id){
                            (this.usuario as Usuario).ativo = e.usuario.ativo;
                            (this.usuario as Usuario).equipes = e.usuario.equipes;
                            (this.usuario as Usuario).turnos = e.usuario.turnos;
                            if(this.usuario?.brigadista){
                                ((this.usuario as Usuario).brigadista as Brigadista).andar_id = (e.usuario.brigadista?.andar_id) as number;
                                ((this.usuario as Usuario).brigadista as Brigadista).turno_id = (e.usuario.brigadista?.turno_id) as number;
                                ((this.usuario as Usuario).brigadista as Brigadista).edificacao_id = (e.usuario.brigadista?.edificacao_id) as number;
                                ((this.usuario as Usuario).brigadista as Brigadista).ativo = (e.usuario.brigadista?.ativo) as boolean;
                            }
                        }
                    })
                    .listen('SimulacaoEvent', (e: {socket: string, simulacao: Simulacao}) => {
                        this.event.next(e);
                    })
                    .listen('ClienteEvent', (e: {socket: string, cliente: Cliente}) => {
                        let c = this.usuario?.cliente as Cliente;
                        c.conf = e.cliente.conf;
                        if(e.cliente.modular){
                            // c.modulos = e.cliente.modulos;
                            c.compras = e.cliente.compras;
                            c.estabelecimentos = e.cliente.estabelecimentos;
                        }
                        this.event.next(e);
                    })
                    .listen('EstabelecimentoEvent', (e: {socket: string, estabelecimento: Estabelecimento}) => {
                        if(this.usuario?.isCliente){
                            const estabelecimento = this.usuario?.cliente?.estabelecimentos.find(i => i.id == e.estabelecimento.id) as Estabelecimento | undefined;
                            if(estabelecimento){
                                estabelecimento.conf = e.estabelecimento.conf;
                                estabelecimento.imagem = e.estabelecimento.imagem;
                            }
                        }else if(this.usuario?.estabelecimento?.id == e.estabelecimento.id){
                            (this.usuario?.estabelecimento as Estabelecimento).conf = e.estabelecimento.conf;
                            (this.usuario?.estabelecimento as Estabelecimento).imagem = e.estabelecimento.imagem;
                        }
                    })
                    .listen('EdificacaoEvent', (e: {socket: string, edificacao: Edificacao}) => {
                        if(this.usuario?.isCliente){
                            const edificacao = this.usuario?.cliente?.edificacoes.find(i => i.id == e.edificacao.id) as Edificacao | undefined;
                            if(edificacao){
                                edificacao.emails = e.edificacao.emails;
                                edificacao.plano_emergencia = e.edificacao.plano_emergencia;
                                edificacao.imagem = e.edificacao.imagem;
                                edificacao.modulos = e.edificacao.modulos;
                                edificacao.documentos = e.edificacao.documentos;
                            }
                        }else if(this.usuario?.edificacao?.id == e.edificacao.id){
                            let ed = (this.usuario?.edificacao as Edificacao);
                            ed.emails = e.edificacao.emails;
                            ed.plano_emergencia = e.edificacao.plano_emergencia;
                            ed.imagem = e.edificacao.imagem;
                            ed.modulos = e.edificacao.modulos;
                            ed.documentos = e.edificacao.documentos;
                        }
                        // console.log('Edif', e.edificacao)
                    })
                    .listen('Mensagem', (e: {socket: string, mensagem: Mensagem}) => {
                        //Verifica se pertence a edificação do usuario
                        let ed;
                        if(this.usuario?.isCliente){
                            ed = this.usuario?.cliente?.edificacoes.find(i => i.id == e.mensagem.edificacao_id);

                        }else if(this.usuario?.edificacao?.id == e.mensagem.edificacao_id){
                            ed = this.usuario.edificacao;
                        }
                        if(ed){
                            if(this.usuario?.configuracao.app.vibrar && this.router.url.indexOf('mensagem') == -1){
                                Haptics.vibrate({duration: 1000});
                            }
                            if (Number(e.mensagem.usuario_id) !== Number(this.usuario?.id)
                                && (document.hidden || this.chatAtivo !== 'e' + e.mensagem.edificacao_id)) {
                                (this.usuario as Usuario).qtd_mensagens++;
                                ed.qtd_mensagens++;
                            }
                            this.event.next(e);
                        }
                    })
                    .listen('MedidorIotEvent', (e: {socket: string, leitura: any}) => {
                        this.event.next(e);
                    })
                    .listen('MedidorIotConfiguracaoEvent', (e: {socket: string, medidor: any}) => {
                        this.event.next(e);
                    })
                    .listen('MedidorIotAlertaEvent', (e: {socket: string, alerta: any}) => {
                        const usuarioId = Number(this.usuario?.id);
                        const destinatario = (e.alerta?.usuario_ids || []).some((id: number | string) => {
                            return Number(id) === usuarioId;
                        });

                        if(!destinatario){
                            return;
                        }

                        const rota = '/medidor-iot-alerta/' + e.alerta.id;
                        if(this.router.url.split('?')[0] != rota){
                            this.router.navigate(
                                ['/medidor-iot-alerta', e.alerta.id],
                                {state: {alerta: e.alerta}}
                            );
                        }
                        this.event.next(e);
                    })
                    .listen('Help', (e: {socket: string, sinistro: Sinistro, user: Usuario}) => {
                        if(!e.sinistro.aberto){
                            this.event.next(e);
                            return;
                        }

                        //Usuario está vinculado ao sinistro e não é ele próprio
                        if(e.sinistro.usuarios?.find(i => i.id == this.usuario?.id) && e.sinistro.usuario_id != this.usuario?.id){
                            const canPlayAlarm = this.canTriggerSinistroAlarm(e);
                            const sinistroRoute = ['/sinistro', e.sinistro.id];
                            const sinistroQuery = {queryParams: {audio: canPlayAlarm ? 'true' : 'false'}};
                            const currentRoute = this.router.url.split('?')[0];
                            const onSinistroRoute = currentRoute == '/sinistro/' + e.sinistro.id || currentRoute == '/sinistro/' + e.sinistro.sinistro_id;

                            if(Capacitor.isNativePlatform() && Capacitor.getPlatform() == 'android'){
                                BackgroundMode.isScreenOff().then((is) => {
                                    if(is.isScreenOff){
                                        return BackgroundMode.wakeUp().then(() => {
                                            return BackgroundMode.unlock().then(() => {
                                                return BackgroundMode.moveToForeground().then(() => {
                                                    if(!onSinistroRoute)
                                                        this.router.navigate(sinistroRoute, sinistroQuery);
                                                    this.event.next(e);
                                                });
                                            });
                                        });
                                    }else{
                                        return BackgroundMode.moveToForeground().then(() => {
                                            if(!onSinistroRoute)
                                                this.router.navigate(sinistroRoute, sinistroQuery);
                                            this.event.next(e);
                                        });
                                    }
                                }).catch(() => {
                                    if(!onSinistroRoute) this.router.navigate(sinistroRoute, sinistroQuery);
                                    this.event.next(e);
                                });
                            }else{
                                if(!onSinistroRoute)
                                    this.router.navigate(sinistroRoute, sinistroQuery);
                                this.event.next(e);
                            }
                        }
                    });
                });
            // }

            //Localização
            this.startGPS();
            if(this.usuario?.isResidente || this.usuario?.isBrigadista || this.usuario?.bombeiro){
                clearInterval(this.GPS);
                this.GPS = setInterval(() => {
                    this.sendGPS();
                }, 60000);
                this.sendGPS();
            }
        }

        //RODAR EM BACKGROUND
        if(Capacitor.isNativePlatform() && Capacitor.getPlatform() == 'android'){
            this.enableAndroidBackgroundMode();

            if(this.androidBackgroundPermissionsChecked) return;
            this.androidBackgroundPermissionsChecked = true;

            BackgroundMode.checkBatteryOptimizations().then(({enabled}) => {
                if(enabled) return BackgroundMode.requestDisableBatteryOptimizations();
                return undefined;
            }).catch(error => console.warn('Battery optimization check unavailable', error)).then(() => {
                return BackgroundPermissions.checkOverlayPermission();
            }).then((r) => {
                if(!r.granted){
                    this.alertController.create({
                        mode: 'ios',
                        header: 'Permissão Necessária!',
                        subHeader: 'pedidos de ajuda',
                        message: 'Quando o aplicativo estiver rodando ao fundo e receber um pedido de ajuda é necessário dar permissão para trazê-lo para primeiro plano. Deseja ir para as configurações e configurar a permissão (sobrepor a outros apps)?',
                        buttons: [
                            {role: 'cancel', text: 'Não'},
                            {
                                role: 'select',
                                text: 'Sim',
                                handler: () => {
                                    NativeSettings.open({
                                        optionAndroid: AndroidSettings.ApplicationDetails,
                                        optionIOS: IOSSettings.App
                                    })
                                }
                            }
                        ]
                    }).then(a => a.present())
                }
            }).catch(error => console.warn('Overlay permission check unavailable', error));
        }

    }

    private async offline(usuario: Usuario | undefined){

        let save = async(file: string | undefined, name: string | undefined = undefined) : Promise<any> => {
            if(file && Capacitor.isNativePlatform()){
                const resp = await CapacitorHttp.get({url: file, responseType: 'blob'});

                return Filesystem.writeFile({
                    path: name || file.substring(file.lastIndexOf('/') + 1).split('?')[0],
                    data: resp.data,
                    directory: Directory.Data,
                    // encoding: Encoding.UTF8,
                });
            }
        };

        // await save(this.usuario?.imagem);

        if(this.usuario?.isCliente)
            this.usuario?.cliente?.estabelecimentos.forEach(async (e, index) => {
                //salva logo
                // if(!usuario || e.updated_at != usuario.cliente?.estabelecimentos[index]?.updated_at)
                //     await save(e.imagem);

                e.edificacoes.forEach(async (ed, i) => {
                    //salva plano
                    if(!usuario || ed.updated_at != usuario.cliente?.estabelecimentos?.[index]?.edificacoes?.[i]?.updated_at){
                        await save(ed.plano_emergencia);
                        await this.edificacaoDB.put(ed);
                    }
                    ed.documentos.forEach(async (doc, c) => {
                        //@TODO talvez remover espaços da descricao
                        if(!usuario || doc.updated_at != usuario.cliente?.estabelecimentos?.[index]?.edificacoes?.[i]?.documentos?.[c]?.updated_at){
                            await save(doc.arquivo, doc.descricao + doc.arquivo.substring(doc.arquivo.lastIndexOf('.')).split('?')[0]);
                        }
                    });
                    //salva rotas
                    ed.andares.forEach(async (a, c) => {
                        if(!usuario || a.updated_at != usuario.cliente?.estabelecimentos?.[index]?.edificacoes?.[i]?.andares?.[c]?.updated_at){
                            await save(a.rota_fuga);
                            await this.andarDB.put(a);
                        }
                    });
                });
            });
        else{
            //salva logo
            // if(!usuario || this.usuario?.estabelecimento?.updated_at != usuario.estabelecimento?.updated_at)
                // await save(this.usuario?.estabelecimento?.imagem);

            //salva plano
            if(!usuario || this.usuario?.edificacao?.updated_at != usuario.edificacao?.updated_at){
                await save(this.usuario?.edificacao?.plano_emergencia);
                await this.edificacaoDB.put(this.usuario?.edificacao);
            }
            this.usuario?.edificacao?.documentos.forEach(async (doc, i) => {
                //@TODO talvez remover espaços da descricao
                if(!usuario || doc.updated_at != usuario.edificacao?.documentos[i]?.updated_at){
                    await save(doc.arquivo, doc.descricao + doc.arquivo.substring(doc.arquivo.lastIndexOf('.')).split('?')[0]);
                }
            });
            //salva rota
            if(this.usuario?.andar && (!usuario || this.usuario?.andar?.updated_at != usuario.andar?.updated_at)){
                await save(this.usuario?.andar?.rota_fuga);
                await this.andarDB.put(this.usuario?.andar);
            }
        }
    }

    private async logCurrentNetworkStatus(){
        const status = await Network.getStatus();

        this.chkConnection(status);
    };

    private chkConnection(status: ConnectionStatus){
        let c = this.usuario?.configuracao.app.connections.find((c: any) => c.name == status.connectionType);
        if(c){
            BaseService.online = c.value;
        }else{
            BaseService.online = status.connectionType == 'none' ? false : true;
        }
        if(BaseService.online){
            if(Capacitor.isNativePlatform()){
                this.sendOfflineQueues();
                this.triggerSincOfflineOnce();
            }
        }
    }

    private async sendOfflineQueues(){
        await this.filaDB.send();
        await this.uploadQueue.send();
    }

    private sincStartupTriggered = false;
    private async triggerSincOfflineOnce(){
        if(this.sincStartupTriggered){
            return;
        }

        if(!this.usuario){
            return;
        }

        if(this.usuario.admin){
            return;
        }

        if(this.usuario.cliente?.modular){
            return;
        }

        if(this.usuario.residente && !this.usuario.perfil){
            return;
        }

        if(!this.usuario.cliente?.conf?.sinc_offline){
            return;
        }

        const session = await this.storage.get('session');

        if(session || PagesPage.session.value){
            if(session){
                PagesPage.session.next(session);
            }
            return;
        }

        this.sincStartupTriggered = true;

        this.sinc.sincroniza();
    }
}
